import type { VueConstructor } from 'vue';
import Vue from 'vue';
import { testimonialStates } from '../constants';
import { testimonialsByStates } from '~/components/partials/public-portfolio/PublicPortfolioTestimonials/utils';
import type { Testimonial } from '~/types/graphql';

export const computed = {
  hasTestimonials(): boolean {
    // @ts-ignore
    return this.testimonials.length > 0;
  },
  visibleTestimonials(): Array<Testimonial> {
    // @ts-ignore
    return testimonialsByStates(this.testimonials, testimonialStates.VISIBLE_TESTIMONIAL_STATES);
  },
  hasVisibleTestimonials(): boolean {
    return this.visibleTestimonials.length > 0;
  },
  archivedTestimonials(): Array<Testimonial> {
    // @ts-ignore
    return testimonialsByStates(this.testimonials, testimonialStates.ARCHIVED_TESTIMONIAL_STATES);
  },
  verifiedTestimonials(): Array<Testimonial> {
    // @ts-ignore
    return testimonialsByStates(this.testimonials, testimonialStates.VERIFIED_TESTIMONIAL_STATES);
  },
  pendingTestimonials(): Array<Testimonial> {
    // @ts-ignore
    return testimonialsByStates(this.testimonials, testimonialStates.PENDING_TESTIMONIAL_STATES);
  },
  actionNeededTestimonials(): Array<Testimonial> {
    // @ts-ignore
    return testimonialsByStates(this.testimonials, testimonialStates.ACTION_NEEDED_TESTIMONIAL_STATES);
  },
  actionNeededTestimonialsCount(): number {
    return this.actionNeededTestimonials.length;
  },
};

const publicPortfolioTestimonialMixin = Vue.extend({
  name: 'PublicPortfolioTestimonialMixin',
  computed,
});
export default publicPortfolioTestimonialMixin;

export type PublicPortfolioTestimonialMixinType = VueConstructor<
  Vue & InstanceType<typeof publicPortfolioTestimonialMixin>
>;
